export { default } from 'redux/containers/components/accordion/AccordionWrapperContainer'
